export const specialDates = [
  { value: 'no', label: 'No' },
  { value: 'puente', label: 'Puente' },
  { value: 'ano_nuevo', label: 'Año Nuevo' },
  { value: 'semana_santa', label: 'Semana Santa' },
  { value: 'semana_pascua', label: 'Semana Pascua' },
  { value: 'navidad', label: 'Navidad' },
  { value: 'verano', label: 'Verano' },
];

export const Providers = [
  /* { value: 'almundo', label: 'Almundo' }, */
  { value: 'kayak', label: 'Kayak' },
  { value: 'momondo', label: 'Momondo' },
  { value: 'skyscanner', label: 'Skyscanner' },
  { value: 'turismocity', label: 'Turismo City' },
  /* { value: 'viajacompara', label: 'Viaja Compara' },
  { value: 'vivaaerobus', label: 'Viva Aerobus' }, */
  { value: 'volaris', label: 'Volaris' },
  { value: 'otra', label: 'Otra' },
];

export const ProvidersFlightHotel = [
  /* { value: 'almundo', label: 'Almundo' },
  { value: 'bdtravel', label: 'BD Travel' }, */
  { value: 'bestday', label: 'Best Day' },
  { value: 'kayak', label: 'Kayak' },
  { value: 'momondo', label: 'Momondo' },
  { value: 'skyscanner', label: 'Skyscanner' },
  { value: 'turismocity', label: 'Turismo City' },
  { value: 'pricetravel', label: 'Price Travel' },
  /* { value: 'viajacompara', label: 'Viaja Compara' },
  { value: 'vivaaerobus', label: 'Viva Aerobus' }, */
  { value: 'volaris', label: 'Volaris' },
  { value: 'otra', label: 'Otra' },
];

export const ProvidersHotel = [
  { value: 'pricetravel', label: 'Price Travel' },
  { value: 'booking', label: 'Booking' },
  { value: 'otra', label: 'Otra' },
];
